<nz-modal
   nzWrapClassName="ncx-modal"
   [(nzVisible)]="addUsersVisible"
   [nzContent]="modalContent"
   [nzFooter]="modalFooter"
   (nzOnCancel)="handleCancel()"
   [nzMaskClosable]="false">
   <ng-template #modalContent>
      <div [attr.data-component]="'@modals/add-users'">
         <p class="header">{{ isNewUser ? 'Add User' : 'Edit User' }}</p>

         <div class="body">
            <section>
               <p class="form-label">First Name</p>
               <div class="form-element">
                  <div class="firstName">
                     <input
                        nz-input
                        placeholder="First Name"
                        [(ngModel)]="editUserDetails.name.firstName" />
                  </div>
               </div>
            </section>

            <section>
               <p class="form-label">Last Name</p>
               <div class="form-element">
                  <input
                     nz-input
                     placeholder="Last Name"
                     [(ngModel)]="editUserDetails.name.lastName" />
               </div>
            </section>

            <section>
               <p class="form-label">Display Name</p>
               <div class="form-element">
                  <input
                     nz-input
                     placeholder="Display Name"
                     [(ngModel)]="editUserDetails.name.preferredName" />
               </div>
            </section>

            <section>
               <p class="form-label">SSO ID</p>
               <div class="form-element">
                  <input
                     nz-input
                     placeholder="SSO ID"
                     [(ngModel)]="editUserDetails.ssoId" />
               </div>
            </section>

            <section>
               <p class="form-label">Email</p>
               <div class="firstName">
                  <input
                     nz-input
                     placeholder="Email ID"
                     [(ngModel)]="editUserDetails.email.workEmail" />
               </div>
            </section>

            <section>
               <p class="form-label">Job Title</p>
               <div class="form-element">
                  <input
                     nz-input
                     placeholder="Job Title"
                     [(ngModel)]="editUserDetails.workInfo.jobTitle" />
               </div>
            </section>

            <section>
               <p class="form-label">Business Unit</p>
               <div class="form-element">
                  <input
                     nz-input
                     placeholder="Business Unit"
                     [(ngModel)]="editUserDetails.businessUnit" />
               </div>
            </section>

            <section>
               <p class="form-label">Organization</p>
               <div class="form-element">
                  <input
                     nz-input
                     placeholder="Organization"
                     [(ngModel)]="editUserDetails.organization" />
               </div>
            </section>

            <section>
               <p class="form-label">Parent Organization ID</p>
               <div class="form-element">
                  <input
                     nz-input
                     placeholder="Parent Organization ID"
                     [(ngModel)]="editUserDetails.parentOrganizationId" />
               </div>
            </section>

            <section>
               <p class="form-label">NCX Role</p>
               <div class="form-element">
                  <nz-select
                     [ngModel]="toUpperCase(editUserDetails.role)"
                     (ngModelChange)="toggleUserRole($event)"
                     nzAllowClear
                     nzPlaceHolder="Choose">
                     <nz-option
                        *ngFor="let index of roles"
                        [nzValue]="index.value"
                        [nzLabel]="index.label"></nz-option>
                  </nz-select>
               </div>
            </section>


            <section *ngIf="!isNewUser">
               <div class="form-label">Date Trained</div>
               <div class="form-element">
                  <nz-date-picker
                     [(ngModel)]="editUserDetails.dateTrained"
                     (ngModelChange)="onChange($event, 'TRAINED_DATE')"
                     nzPlaceHolder="Select Date Trained"></nz-date-picker>
               </div>
            </section>

             <hr class="hr-clr" />

            <section>
               <p class="form-label">
                  <input
                     [value]="editUserDetails.ldapActive"
                     type="checkbox"
                     style="margin-right: 10px"
                     [(ngModel)]="editUserDetails.ldapActive" />
                  NDI Account Status
               </p>
            </section>
         </div>
      </div>
   </ng-template>

   <ng-template #modalFooter>
      <button
         nz-button
         nzType="default"
         (click)="handleCancel()">
         Cancel
      </button>
      <button
         *ngIf="!isNewUser"
         nz-button
         nzType="primary"
         (click)="handleOk()">
         Save Changes
      </button>
      <button
         *ngIf="isNewUser"
         nz-button
         nzType="primary"
         (click)="addUser()">
         Add User
      </button>
   </ng-template>
</nz-modal>
